/** Frontmatter for the "week7-waiver-wire-darkness-report" article; the Body lives in week7-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week7-waiver-wire-darkness-report',
  title: 'Week 7 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt:
    'Tanner McKee, Omar Cooper Jr. and DeMario Douglas lead a Week 7 wire shaped by Jalen Hurts\' blood clots, Davante Adams\' hamstring and a Week 6 report card that says target share beats touchdowns. A FAAB ladder, the full board, a superflex corner, a D/ST streaming chart built on implied totals, an IDP board, the injury ledger, the Week 6 receipts and the bid sheet.',
  readMinutes: 15,
  date: '2026-10-20',
};

export default meta;
